import { render, staticRenderFns } from "./ContrastReport.vue?vue&type=template&id=5c8a3730&scoped=true"
import script from "./ContrastReport.vue?vue&type=script&lang=js"
export * from "./ContrastReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8a3730",
  null
  
)

export default component.exports